<template>
  <div>
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row>
        <el-form-item label="机构名称全称" prop="orgFullName">
          <el-input
            clearable
            disabled
            v-model="formData.orgFullName"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row :gutter="20">
        <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 8}">
          <el-form-item label="机构名称" prop="orgName">
            <el-input
              clearable
              v-model="formData.orgName"
              placeholder="请输入机构名称"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 8}">
          <el-form-item label="上级机构">
            <org-cascader
              :disabled="parentOrgDisableChange"
              :valueString.sync="formData.allOrgCode"
              :lastValue.sync="formData.parentOrgCode"
              :pathLabels.sync="orgParentFullName"
              :level.sync="formData.classLevel"
              :props="{checkStrictly: true}"
              :dataScope="false"
            />
          </el-form-item>
        </el-col>

        <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 8}">
          <el-form-item label="机构负责人" prop="orgLeader">
            <el-input
              clearable
              v-model="formData.orgLeader"
              placeholder="请输入机构负责人"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 8}">
          <el-form-item label="机构负责人手机号" prop="orgLeaderMobile">
            <el-input
              clearable
              v-model.number="formData.orgLeaderMobile"
              placeholder="请输入机构负责人手机号"
              :maxlength="11"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 8}">
          <el-form-item label="省/市/区县">
            <region-cascader
              :show="regionShow"
              :provinceCode.sync="formData.provinceCode"
              :provinceName.sync="formData.provinceName"
              :cityCode.sync="formData.cityCode"
              :cityName.sync="formData.cityName"
              :districtCode.sync="formData.districtCode"
              :districtName.sync="formData.districtName"
            />
          </el-form-item>
        </el-col>

        <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 8}">
          <el-form-item label="详细地址" prop="orgAddress">
            <el-input
              clearable
              v-model="formData.orgAddress"
              placeholder="请输入详细地址"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 8}">
          <el-form-item label="电话" prop="orgPhoneNo">
            <el-input
              clearable
              v-model="formData.orgPhoneNo"
              placeholder="请输入电话"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 8}">
          <el-form-item label="有效状态">
            <el-radio-group v-model="formData.orgStatus" style="width:100%;">
              <el-radio label="Y">有效</el-radio>
              <el-radio label="N">无效</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      title="提示信息"
      :visible.sync="backDialogVisible"
      v-el-dialog-drag
      width="30%"
    >
      <span>是否要保存更改</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small"
          >取消</el-button
        >
        <el-button @click="close()" size="small">不保存</el-button>
        <el-button type="primary" size="small">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    type: String,
    disabled: Boolean,
    params: {type: Object, default: () => {}},
  },
  components: {},
  data() {
    return {
      regionShow: false,
      backDialogVisible: false,
      formData: {
        orgStatus: 'Y',
      },
      orgParentFullName: '',
      rules: {
        orgName: [{required: true, message: '请输入机构名称', trigger: 'blur'}],
      },
    }
  },
  computed: {
    parentOrgDisableChange() {
      return this.type === 'edit'
    },
  },
  watch: {
    orgParentFullName() {
      this.changeFullName()
    },
    'formData.orgName'() {
      this.changeFullName()
    },
    params: {
      handler(val) {
        if (!val) return
        let {
          orgCode = '',
          allOrgCode = '',
          classLevel = -1,
          orgFullName = '',
        } = val
        if (this.type === 'add') {
          this.formData.parentOrgCode = orgCode
          this.formData.classLevel = ++classLevel
          this.formData.allOrgCode = allOrgCode
          this.orgParentFullName = orgFullName
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    changeFullName() {
      if (!this.formData.orgName) return (this.formData.orgFullName = '')
      const fullName = [this.orgParentFullName, this.formData.orgName]
      this.formData.orgFullName = fullName.filter(Boolean).join('/')
    },
    getData() {
      if (this.type === 'add' || !this.params.orgCode)
        return (this.regionShow = true)
      this.$api
        .sysOrganizationDetailApi({
          orgCode: this.params.orgCode,
        })
        .then((res) => {
          this.formData = res.body
          this.regionShow = true
          // 回显组织机构全名称
          const index = this.formData.orgFullName.lastIndexOf('/')
          this.orgParentFullName =
            index < 0 ? '' : this.formData.orgFullName.slice(0, index)

          // 回显上级机构
          let allOrgCode = JSON.parse(this.formData.allOrgCode)
          allOrgCode.pop()
          this.formData.allOrgCode = JSON.stringify(allOrgCode)
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) return

      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$api
        .sysOrganizationSaveApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
